export default __webpack_public_path__ + "slices/main/assets/public/media/glint-logo.662dd6af7796c47679c74f766925b6b1.png";